import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface StaffCaseCreationState {
  /** True while staff (collector, CA, admin, …) is creating a case on behalf of a patient (unified intake UI). */
  isStaffIntake: boolean;
  /**
   * The patient a staff case is being created for, when that patient was never invited to the platform (for a
   * dependent, when the guardian was never invited). Their medical and dental history steps are optional.
   */
  notInvitedPatientId: number | null;
}

const initialState: StaffCaseCreationState = {
  isStaffIntake: false,
  notInvitedPatientId: null,
};

const staffCaseCreationSlice = createSlice({
  name: 'staffCaseCreation',
  initialState,
  reducers: {
    setStaffIntakeInProgress: (state, action: PayloadAction<boolean>) => {
      state.isStaffIntake = action.payload;
    },
    setNotInvitedPatientId: (state, action: PayloadAction<number | null>) => {
      state.notInvitedPatientId = action.payload;
    },
  },
});

export const { setStaffIntakeInProgress, setNotInvitedPatientId } = staffCaseCreationSlice.actions;
export default staffCaseCreationSlice.reducer;
